/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const OverflowIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25015 12C8.25015 12.9665 7.4667 13.75 6.50026 13.75C5.53382 13.75 4.75037 12.9665 4.75037 12C4.75037 11.0335 5.53382 10.25 6.50026 10.25C7.4667 10.25 8.25015 11.0335 8.25015 12ZM13.7499 12C13.7499 12.9665 12.9665 13.75 12 13.75C11.0336 13.75 10.2501 12.9665 10.2501 12C10.2501 11.0335 11.0336 10.25 12 10.25C12.9665 10.25 13.7499 11.0335 13.7499 12ZM17.4998 13.75C18.4662 13.75 19.2497 12.9665 19.2497 12C19.2497 11.0335 18.4662 10.25 17.4998 10.25C16.5333 10.25 15.7499 11.0335 15.7499 12C15.7499 12.9665 16.5333 13.75 17.4998 13.75Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
